import * as React from "react";

export const ErrorMessage: React.FC<{ msg: string | string[] | undefined }> = ({
  msg,
}) =>
  msg ? (
    Array.isArray(msg) ? (
      <>
        {msg.map((m) => (
          <p className="help is-danger" key={m}>
            {m}
          </p>
        ))}
      </>
    ) : (
      <p className="help is-danger">{msg}</p>
    )
  ) : null;
